import "dragscroll";

class OverflowScroll {
    constructor(selector = ".js-overflow", child = ".js-overflow-child") {
        this.selector = selector;
        this.child = child;
        this.scrollPosition = 0;
    }

    init() {
        const overflowTarget = Array.from(
            document.querySelectorAll(this.selector)
        );

        overflowTarget.forEach(container => {
            const child = container.querySelector(this.child);

            this.setStyle(container, child);
            this.onScroll(container, child);
        });
    }

    determineOverflow(content, container) {
        const containerMetrics = container.getBoundingClientRect();
        const containerMetricsRight = Math.floor(containerMetrics.right);
        const containerMetricsLeft = Math.floor(containerMetrics.left);
        const contentMetrics = content.getBoundingClientRect();
        const contentMetricsRight = Math.floor(contentMetrics.right);
        const contentMetricsLeft = Math.floor(contentMetrics.left);
        if (
            containerMetricsLeft > contentMetricsLeft &&
            containerMetricsRight < contentMetricsRight
        ) {
            return "both";
        } else if (contentMetricsLeft < containerMetricsLeft) {
            return "left";
        } else if (contentMetricsRight > containerMetricsRight) {
            return "right";
        } else {
            return "none";
        }
    }

    setStyle(container, child) {
        const nav = child;
        const overflowState = this.determineOverflow(nav, container);

        container.setAttribute("data-overflowing", overflowState);
    }

    onScroll(container, child) {
        container.addEventListener("scroll", () => {
            this.setStyle(container, child);
        });
    }
}

export default OverflowScroll;



// WEBPACK FOOTER //
// ./js/overflowScroll.js